'use client'

import { Drawer, Fieldset } from "@mantine/core";
import Link from "next/link";
import { FaHome, FaSeedling, FaStickyNote, FaCog } from "react-icons/fa";
import { GiCycle, GiBookshelf } from "react-icons/gi";
import { SignOutHook } from "../hooks/sign-out";
import { IoExitOutline } from "react-icons/io5";
import { useModalStore } from "@/context/modalStore";
import { GoSignIn } from "react-icons/go";
import { TfiWrite } from "react-icons/tfi";


export default function NavDrawer({ opened, close, setGlobalLoading, userVerified }: Readonly<{ opened: boolean; close: () => void; setGlobalLoading: (loading: boolean) => void; userVerified: boolean; }>) {

    const setSigninModal = useModalStore(state => state.setOpenSignInModal);
    const setRegisterModal = useModalStore(state => state.setOpenRegisterModal);

    return (
        <Drawer
            variant="unstyled"
            offset={8}
            radius={'md'}
            opened={opened}
            onClose={() => { close(); }}
            bg={'transparent'}
            color="transparent"
            title={
                <Link href={'/'} onClick={() => { close(); setGlobalLoading(true); }} className="px-3 py-1 sm:py-3 rounded-md cursor-pointer flex flex-row justify-start items-center space-x-2 hover:bg-emerald-700 w-full h-content hover:text-white font-semibold text-black cursor-pointer hover:underline hover:text-white w-full">
                    <FaHome className="cursor-pointer pr-1" size={18} />
                    Plantr Co.
                </Link>
            }
            size="sm"
            position="left"
            styles={{
                header: { backgroundColor: '#79d198ff', padding: '6px 16px', borderBottom: '1px solid rgba(211, 231, 253, 0.91)' },
                content: { backgroundColor: '#79d198ff' },
            }}
            closeOnClickOutside
            closeOnEscape
            overlayProps={{ blur: 4 }}
        >
            <Fieldset variant="unstyled" p={'sm'} className={`w-full h-content space-y-3 px-3 bg-slate-100/70 rounded-md shadow-[inset_0_2px_8px_rgba(0,0,0,0.10),inset_0_-2px_8px_rgba(0,0,0,0.10)] border border-gray-300 overflow-hidden`} legend={<p className="font-semibold pt-12">Navigation</p>} styles={{ root: { borderRadius: '8px' } }}>
                <Link href={'/catalog'} onClick={() => { setGlobalLoading(true); close(); }} className={`flex flex-row justify-between items-center w-full p-3 rounded-md bg-emerald-600 hover:bg-emerald-700 transition-colors hover:underline`}>

                    <p className={`text-[12px] sm:text-[14px] md:text-[16px] text-start w-content h-content font-semibold truncate text-white`}>
                        Plant Info
                    </p>
                    <GiBookshelf size={16} color="white" />

                </Link>
                <Link href={'/plants'} onClick={() => { setGlobalLoading(true); close(); }} className={`flex flex-row justify-between items-center w-full p-3 rounded-md bg-emerald-600 hover:bg-emerald-700 transition-colors hover:underline`}>

                    <p className={`text-[12px] sm:text-[14px] md:text-[16px] text-start w-content h-content font-semibold truncate text-white`}>
                        Plants
                    </p>
                    <FaSeedling size={16} color="white" />

                </Link>
                <Link href={'/growing'} onClick={() => { setGlobalLoading(true); close(); }} className={`flex flex-row justify-between items-center w-full p-3 rounded-md bg-emerald-600 hover:bg-emerald-700 transition-colors hover:underline`}>
                    <p className={`text-[12px] sm:text-[14px] md:text-[16px] text-start w-content h-content font-semibold truncate text-white`}>
                        Growing
                    </p>
                    <GiCycle size={16} color="white" />

                </Link>
                <Link href={'/notes'} onClick={() => { setGlobalLoading(true); close(); }} className={`flex flex-row justify-between items-center w-full p-3 rounded-md bg-emerald-600 hover:bg-emerald-700 transition-colors hover:underline`}>

                    <p className={`text-[12px] sm:text-[14px] md:text-[16px] text-start w-content h-content font-semibold truncate text-white`}>
                        Notes
                    </p>
                    <FaStickyNote size={16} color="white" />

                </Link>
            </Fieldset>

            {userVerified ? (
                <Fieldset variant="unstyled" p={'sm'} className={`w-full h-content space-y-3 px-3 bg-slate-100/70 rounded-md shadow-[inset_0_2px_8px_rgba(0,0,0,0.10),inset_0_-2px_8px_rgba(0,0,0,0.10)] border border-gray-300 overflow-hidden`} legend={<p className="font-semibold pt-12">User</p>} styles={{ root: { borderRadius: '8px' } }}>
                    <Link href={'/settings'} onClick={() => { setGlobalLoading(true); close(); }} className={`flex flex-row justify-between items-center w-full p-3 rounded-md bg-emerald-600 hover:bg-emerald-700 transition-colors hover:underline`}>

                        <p className={`text-[12px] sm:text-[14px] md:text-[16px] text-start w-content h-content font-semibold truncate text-white`}>
                            Settings
                        </p>
                        <FaCog size={16} color="white" />

                    </Link>
                    <button
                        type="button"
                        onClick={() => SignOutHook().confirmSignOut()}
                        className={`flex flex-row justify-between items-center w-full p-3 rounded-md bg-emerald-600 hover:bg-emerald-700 transition-colors hover:underline cursor-pointer`}
                    >

                        <p className={`text-[12px] sm:text-[14px] md:text-[16px] text-start w-content h-content font-semibold truncate text-white`}>
                            {'Sign Out'}
                        </p>
                        <IoExitOutline size={18} color="white" />

                    </button>
                </Fieldset>
            ) : (
                <Fieldset variant="unstyled" p={'sm'} className={`w-full h-content space-y-3 px-3 bg-slate-100/70 rounded-md shadow-[inset_0_2px_8px_rgba(0,0,0,0.10),inset_0_-2px_8px_rgba(0,0,0,0.10)] border border-gray-300 overflow-hidden`} legend={<p className="font-semibold pt-12">User</p>} styles={{ root: { borderRadius: '8px' } }}>
                    <button
                        type="button"
                        onClick={() => setRegisterModal(true)}
                        className={`flex flex-row justify-between items-center w-full p-3 rounded-md bg-emerald-600 hover:bg-emerald-700 transition-colors hover:underline cursor-pointer`}
                    >

                        <p className={`text-[12px] sm:text-[14px] md:text-[16px] text-start w-content h-content font-semibold truncate text-white`}>
                            {'Register'}
                        </p>
                        <TfiWrite size={18} color="white" />

                    </button>
                    <button
                        type="button"
                        onClick={() => setSigninModal(true)}
                        className={`flex flex-row justify-between items-center w-full p-3 rounded-md bg-emerald-600 hover:bg-emerald-700 transition-colors hover:underline cursor-pointer`}
                    >

                        <p className={`text-[12px] sm:text-[14px] md:text-[16px] text-start w-content h-content font-semibold truncate text-white`}>
                            {'Sign In'}
                        </p>
                        <GoSignIn size={18} color="white" />

                    </button>
                </Fieldset>
            )}
        </Drawer>
    )
}
